module.exports = __webpack_public_path__ + "img/recycle-bin-interface-symbol.583f0b5f.svg";